import axios from 'axios';
import router from '../router';

// const viewToken = '4c441734-b6ef-4306-9a9e-ec82cec7c597';

axios.interceptors.request.use(
    config => {
        if (window.BASE_APP_PATH) {
            config.url = window.BASE_APP_PATH + config.url;
        }
        config.url +=
        (config.url.indexOf('?') > 0 ? '&' : '?') +
        `cb=${new Date().getTime()}`;

        return config;
    },
    err => {
        throw new Error(err);
    }
);

let systemEnv = '';
let redirectUri = '';
axios.interceptors.response.use((response) => {
    const { data } = response;
    if (data.env) {
        systemEnv = data.env;
        redirectUri = data.redirectUri;

    }

    if (data.code == 3001004 && !location.search.includes('zwdt_access_token') && location.pathname !== '/ukey-login') {
        // 跳转过一次，就不再跳转
        if (sessionStorage.getItem('REDIRECT_COUNTER')) return Promise.resolve(response);

        const isProduct = systemEnv === 'production';
        const redirectHost = isProduct ? 'https://zwdtuser.sh.gov.cn' : 'http://117.184.226.149';

        window.location.href = redirectHost + '/uc/naturalUser/jumpSendTo.do?redirect_uri=' + redirectUri;
        // 已经跳转过了
        sessionStorage.setItem('REDIRECT_COUNTER', '1');
        return Promise.reject();
    }
    return Promise.resolve(response);
});

if (window.API) {
    axios.interceptors.request.use(
        config => {
            config.url = window.API + config.url;
            config.withCredentials = true;
            return config;
        },
        err => {
            throw new Error(err);
        }
    );
} else {
    axios.interceptors.request.use(
        config => {
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            return config;
        },
        err => {
            throw new Error(err);
        }
    );
}

export default axios;
